<template>
  <div class="mx-auto my-2">
    <ValidationObserver
        ref="observer"
        class="transition duration-500 ease-in-out transform w-full"
        style="transition: all 1s !important"
        tag="form"
        @submit.prevent="submit()"
    >
      <v-card class="basil">
        <v-card-title class="text-left justify-left py-6">
          Register New Trainees
        </v-card-title>

        <div class='flex justify-end gap-3'>
          <v-btn
              class="primary white--text"
              depressed
              @click="newImport"
          >
            <v-icon left>mdi-import</v-icon>
            <span>New Import</span>
          </v-btn>
        </div>

        <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
          <v-tab v-for="tabItem in tabItems" :key="tabItem">
            {{ tabItem }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="tabItem in tabItems" :key="tabItem">
            <div v-if="tabItem === 'Add New Trainee'  && !showForm">
              <v-alert
                  border="left"
                  color="blue"
                  colored-border
                  dense
                  elevation="2"
                  icon="mdi-information-variant"
              >
                Please use this
                <strong>
                  <a download @click="prepareExel">Trainee Sample</a>
                </strong>
                excel file before upload!
                <strong>
                  Or
                  <a
                      style="text-decoration: underline; font-style: italic"
                      @click="goBack()"
                  >Go Back</a
                  >
                </strong>
              </v-alert>
              <div v-if="!showForm && !showUpload" class="mb-6">
                <upload-excel-component
                    :before-upload="beforeUpload"
                    :on-success="handleSuccess"
                />
              </div>
              <div v-if="showUpload" class="selected mb-6">
                Selected file: {{ fileName }}
                <v-btn v-if="!loading" color="primary" @click="uploadTrainees"
                >
                  <v-icon dark>mdi-cloud-upload</v-icon>
                  Upload
                </v-btn>
                <v-container v-if="loading" style="height: 100px">
                  <v-row align-content="center" class="fill-height" justify="center">
                    <v-col class="subtitle-1 text-center" cols="12"
                    >Uploading your file
                    </v-col
                    >
                    <v-col cols="6">
                      <v-progress-linear
                          color="primary accent-4"
                          height="6"
                          indeterminate
                          rounded
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
              <v-data-table
                  v-if="showCsv"
                  :headers="csvHeaders"
                  :items="csvResults"
                  :server-items-length="csvResults.count"
                  class="elevation-1"
                  loading-text="Loading... please wait"
              />
              <importErrorModal
                  :dialogState="importErrorsDialog"
                  :importErrors="importErrors"
                  @dialogEvent="() =>importErrorsDialog = false"
              ></importErrorModal>
            </div>
            <div v-if="tabItem === 'Add New Trainee'  && showForm">
              <div class="w-full flex py-5 mb-6">
                <v-card
                    class="mx-auto w-full"
                    flat
                    max-height="auto"
                    max-width="1000"
                >
                  <v-divider></v-divider>

                  <div class="flex flex-wrap my-6 mx-6 mb-6">
                    <div class="w-full md:w-1/2 px-3 pt-3 mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Prefix</label
                      >
                      <v-select
                          v-model="formValues.prefix"
                          :elevation="1"
                          :items="prefixes"
                          dense
                          item-text="name"
                          item-value="name"
                          label="prefix"
                          solo
                      ></v-select>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required mt-3">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >First Name</label
                      >
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                          required: true,
                          regex: '^[A-Za-z][A-Za-z ]*$',
                        }"
                      >
                        <input
                            id="firstName"
                            v-model="formValues.firstName"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="text"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Father Name</label
                      >
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                          required: true,
                          regex: '^[A-Za-z][A-Za-z ]*$',
                        }"
                      >
                        <input
                            id="middleName"
                            v-model="formValues.middleName"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="text"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Grandfather Name</label
                      >
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                          required: true,
                          regex: '^[A-Za-z][A-Za-z ]*$',
                        }"
                      >
                        <input
                            id="lastName"
                            v-model="formValues.lastName"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="text"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Gender</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <input
                            id="Male"
                            v-model="formValues.gender"
                            class="my-3 ml-5"
                            type="radio"
                            value="Male"
                        />
                        <label for="Male"> Male </label>
                        <br/>

                        <input
                            id="Female"
                            v-model="formValues.gender"
                            class="my-3 ml-5"
                            type="radio"
                            value="Female"
                        />
                        <label for="Female"> Female </label>
                        <br/>
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Proffesion</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-select
                            v-model="formValues.healthProfessionId"
                            :elevation="1"
                            :items="PROFESSIONS"
                            :loading="professionLoading"
                            dense
                            item-text="name"
                            item-value="id"
                            solo
                        ></v-select>

                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Region</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-select
                            v-model="defaultRegion"
                            :elevation="1"
                            :items="REGIONS"
                            :loading="regionLoading"
                            dense
                            item-text="name"
                            item-value="id"
                            return-object
                            solo
                            @change="regionOnChange($event)"
                        >
                        </v-select>

                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>

                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Zone</label
                      >

                      <v-autocomplete
                          v-model="defaultZone"
                          :clearable="true"
                          :elevation="1"
                          :items="FILTERED_ZONES"
                          :loading="zoneLoading"
                          dense
                          item-text="name"
                          item-value="id"
                          return-object
                          solo
                          @change="zoneOnChange($event)"
                      >
                      </v-autocomplete>

                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Woreda</label
                      >

                      <v-autocomplete
                          v-model="formValues.woredaId"
                          :clearable="true"
                          :elevation="1"
                          :items="FILTERED_WOREDAS"
                          :loading="woredaLoading"
                          dense
                          item-text="name"
                          item-value="id"
                          return-object
                          solo
                          @change="woredaOnChange($event)"
                      >
                      </v-autocomplete>

                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Kebele</label
                      >

                      <input
                          id="kebele"
                          v-model="formValues.kebele"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          name
                          type="text"
                      />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <v-checkbox v-model="formValues.unemployed" style="float: left; text-align: left; margin-top: 0;"
                                  @change="unemployedChanged()"></v-checkbox>
                      Unemployed?
                    </div>
                    <div v-if="!unemployed" class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Facility</label
                      >
                      <validation-provider v-slot="{ errors }" rules="required">
                        <v-autocomplete
                            v-model="formValues.facilityId"
                            :clearable="clearable"
                            :elevation="1"
                            :items="NEW_TRAINEE_FACILITIES"
                            :loading="facilityLoading"
                            :searchable="searchable"
                            dense
                            hint="search for facility"
                            item-text="name"
                            item-value="id"
                            persistent-hint
                            return-object
                            solo
                            @change="facilityOnChange($event)"
                        >
                        </v-autocomplete>

                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Email Address</label
                      >
                      <validation-provider v-slot="{ errors }">
                        <input
                            id="facilityEmail"
                            v-model="formValues.facilityEmail"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="email"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                      <br/>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 required">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Phone number</label
                      >
                      <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                          required: true,
                          phone_regex:
                            '^([+]2519|2519|09|9)\\d{8}|^(0|[+]251|251)\\d{9}',
                        }"
                      >
                        <input
                            id="phoneNumber"
                            v-model="formValues.phoneNumber"
                            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            name
                            type="number"
                        />
                        <span
                            class="text-gray-600 text-xs italic text-red-700"
                        >{{ errors[0] }}</span
                        >
                      </validation-provider>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >Employee Id</label
                      >

                      <input
                          id="employeeId"
                          v-model="formValues.employeeId"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          name
                          type="text"
                      />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      >License number</label
                      >

                      <input
                          id="licenseNumber"
                          v-model="formValues.licenseNumber"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          name
                          type="text"
                      />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-0 md:mb-0 mt-2">
                      <label
                          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-2"
                      >National ID</label
                      >

                      <input
                          id="licenseNumber"
                          v-model="formValues.national_id"
                          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          name
                          type="text"
                      />
                    </div>
                  </div>

                  <div class="flex flex-wrap my-6 mx-6 mb-6">
                    <div class="w-full">
                      <v-btn
                          class="float-left shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none white--text font-bold py-2 px-4 rounded"
                          color="blue-grey"
                          @click="backToTrainee()"
                      >
                        <v-icon dark left> mdi-arrow-left</v-icon>
                        Back
                      </v-btn>
                      <button
                          class="float-right shadow bg-teal-600 hover:bg-teal-600 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                          type="button"
                          @click="submit()"
                      >
                        Add Trainee
                      </button>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
            <div v-if="tabItem === 'New Trainee History'">
              <v-text-field
                  v-model="searchNewTrainee"
                  append-icon="mdi-magnify"
                  hide-details
                  label="Search"
                  single-line
                  style="padding: 6px 31px; width: 35%"
              ></v-text-field>
              <v-card class="mx-4" flat>
                <v-data-table
                    :headers="newTraineeheaders"
                    :items="newTrainees.rows"
                    :loading="loading"
                    :options.sync="options"
                    :server-items-length="newTrainees.count"
                    class="elevation-1"
                    loading-text="Loading... please wait">
                  >
                  <template v-slot:[`item.fullName`]="{ item }">
                    <label for="item">
                      {{ item?.prefix }}
                      {{ item?.firstName }} {{ item?.middleName }} {{ item?.lastName }}
                    </label>
                  </template>
                  <template v-slot:[`item.location`]="{ item }">
                    <label for="item">{{ item?.woreda?.name ?? item?.facility?.woreda?.name }}</label>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                            class="mr-2"
                            style="color: teal"
                            @click="editNewTrainee(item)"
                            v-on="on"
                        >mdi-circle-edit-outline
                        </v-icon
                        >
                      </template>
                      <span>Edit New Trainee</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card>

              <template>
                <v-dialog v-model="editDialog" persistent width="60%">
                  <v-card>
                    <v-card-title
                        class="headline font-weight-regular blue-grey white--text"
                        primary-title
                    >{{ title }}

                      <v-spacer></v-spacer>

                      <v-btn color="white" text @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title
                    >

                    <v-divider></v-divider>
                    <HrdNewTraineeEdit
                        v-if="editDialog"
                        :newTrainee="newTrainee"
                        @close="closeDialog()"
                        @updateTrainee="updateTrainee"
                    ></HrdNewTraineeEdit>
                  </v-card>
                </v-dialog>
              </template>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </ValidationObserver>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {email, regex, required} from "vee-validate/dist/rules";
import {
  getFacilitiesByWoredaId,
  getHealthProfessions,
  getRegionList,
  getWoredaByZoneId,
  getZoneByRegionId
} from "../../../utils/helper";
import {TraineeService} from "../trainees.service";
import HrdNewTraineeEdit from "./hrd-new-trainee-edit.vue";
import {PrefixEnum} from "@/utils/enums";
import UploadExcelComponent from "@/components/Graduates/UploadExcel.vue";
import importErrorModal from "@/components/Graduates/importErrorModal.vue";

const ExcelJS = require('exceljs');
const {saveAs} = require('file-saver');


extend("required", {
  ...required,
  message: "This field is required",
});

extend("phone_regex", {
  ...regex,
  message: "Invalid phone number",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});

extend("email", {
  ...email,
  message: "Facility email must be valid",
});

export default {
  props: {
    fromRoute: String,
  },
  components: {
    importErrorModal,
    UploadExcelComponent,
    ValidationObserver,
    ValidationProvider,
    HrdNewTraineeEdit,
  },
  data() {
    return {
      formValues: {
        firstName: "",
        middleName: "",
        lastName: "",
        healthProfessionId: null,
        woredaId: null,
        phoneNumber: "",
        licenseNumber: "",
        employeeId: null,
        facilityId: null,
        gender: "",
        kebele: null,
        facilityEmail: null,
        unemployed: false,
        national_id: "",
        prefixes: [],
      },
      defaultRegion: null,
      REGIONS: [],
      defaultZone: null,
      PROFESSIONS: [],
      FILTERED_ZONES: [],
      FILTERED_WOREDAS: [],
      tab: null,
      tabItems: ["Add New Trainee", "New Trainee History"],
      loading: false,
      newTraineeheaders: [
        {text: "Full Name", value: "fullName"},
        {text: "Gender", value: "gender"},
        {text: "Phone Number", value: "phoneNumber"},
        {text: "Employee Id", value: "employeeId"},
        {text: "License Number", value: "licenseNumber"},
        {text: "Profession", value: "healthProfession.name"},
        {text: "Location", value: "location"},
        {text: "Facility", value: "facility.name"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      newTrainees: [],
      searchNewTrainee: "",
      newTrainee: null,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      editDialog: false,
      NEW_TRAINEE_FACILITIES: [],
      traineeListLoading: false,
      regionLoading: false,
      professionLoading: false,
      facilityLoading: false,
      woredaLoading: false,
      zoneLoading: false,
      searchable: true,
      clearable: true,
      unemployed: false,

      region: [],
      profession: [],
      showForm: true,
      showUpload: false,
      showUploadExcel: false,
      fileName: "",
      importErrors: [],
      importErrorsDialog: false,
      showCsv: false,
      csvHeaders: [],
      csvResults: [],
      mappedCsv: [],
      importedData: [],
    };
  },
  async created() {
    this.prefixes = await PrefixEnum;
  },
  async beforeMount() {
    if (this.fromRoute === "Add") {
      this.tab = 0;
    } else if (this.fromRoute === "History") {
      this.tab = 1;
    } else {
      this.tab = 0;
    }
    this.fetchNewTrainees();
    this.regionLoading = true;
    this.professionLoading = true;
    this.facilityLoading = true;
    this.REGIONS = await getRegionList();
    this.regionLoading = false;
    const healthProfs = await getHealthProfessions();
    this.PROFESSIONS = healthProfs.rows.filter((data) => {
      return data.isActive == true;
    });
    this.professionLoading = false;

    this.regionOnChange();
    this.zoneOnChange();
    this.woredaOnChange();
  },
  watch: {
    options: {
      handler() {
        this.fetchNewTrainees();
      },
      deep: true,
    },
    search: function (val) {
      this.search = val;
      this.fetchNewTrainees();
    },
    searchNewTrainee: function (val) {
      this.searchNewTrainee = val;
      this.fetchNewTrainees();
    },
  },
  methods: {
    async regionOnChange(event = null) {
      this.zoneLoading = true;
      this.FILTERED_ZONES = await getZoneByRegionId(event?.id);
      this.defaultZone = null;
      this.zoneLoading = false;
    },
    async zoneOnChange(event = null) {
      this.woredaLoading = true;
      this.FILTERED_WOREDAS = await getWoredaByZoneId(event?.id);
      this.defaultRegion = event?.regionId;
      this.formValues.woredaId = null;
      this.woredaLoading = false;
    },
    async woredaOnChange(event = null) {
      this.facilityLoading = true;
      this.formValues.woredaId = event?.id;
      this.NEW_TRAINEE_FACILITIES = await getFacilitiesByWoredaId(event?.id);
      this.defaultZone = this.FILTERED_ZONES?.find(x => x.id == event?.zoneId);
      this.defaultRegion = this.defaultZone?.regionId;
      this.formValues.facilityId = null;
      this.facilityLoading = false;
    },
    async facilityOnChange(event = null) {
      this.formValues.facilityId = event?.id;
      let woreda = this.FILTERED_WOREDAS?.find(x => x.id == event?.woredaId);
      this.formValues.woredaId = woreda?.id;
      this.defaultZone = this.FILTERED_ZONES?.find(x => x.id == woreda?.zoneId);
      this.defaultRegion = this.defaultZone?.regionId;
    },
    backToTrainee() {
      this.$router.push({
        path: "/traineeRegistration",
        name: "Trainee",
        params: {fromRoute: "Back"},
      });
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();

      let res = null;
      res = await TraineeService.registerTrainee(this.formValues);

      if (res.data.resultCode == 0) {
        this.$toast.error(res.data.message);
      }
      if (res.status === 200) {
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.$router.push({
              path: "/traineeRegistration",
              name: "Trainee",
              params: {fromRoute: "Add"},
            });
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
      }
    },
    editNewTrainee(item) {
      this.newTrainee = item;
      this.title = "Edit Trainee";
      this.editDialog = true;
    },
    async fetchNewTrainees() {
      this.traineeListLoading = true;
      const {page, itemsPerPage} = this.options;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      this.searchNewTrainee !== null && (params += '&name=' + this.searchNewTrainee);
      const res = await TraineeService.getTraineesList(params);
      if (res.status === 200) {
        this.newTrainees = res.data;
        this.traineeListLoading = false;
      }
      this.traineeListLoading = false;
    },
    closeDialog() {
      this.editDialog = false;
      this.fetchNewTrainees();
    },
    async updateTrainee(trainee) {
      let res = null;

      res = await TraineeService.updateNewTrainee(trainee.id, trainee);
      if (res.status === 201) {
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            this.fetchNewTrainees();
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
      } else {
        this.$toast.error("Unable to update trainee, please try again");
      }
    },
    unemployedChanged() {
      this.unemployed = !this.unemployed;
    },
    newImport() {
      this.showForm = false;
    },
    goBack() {
      this.showForm = true;
    },
    handleSuccess({results, fileName}) {
      let errors = [];
      const requiredFields = [
        "firstName",
        "fatherName",
        "grandfatherName",
        "gender",
        "phoneNumber",
        "profession",
        "region",
      ];

      const regionLookup = this.REGIONS.reduce((acc, region) => {
        acc[region.name] = region.id;
        return acc;
      }, {});
      const professionLookup = this.PROFESSIONS.reduce((acc, prof) => {
        acc[prof.name] = prof.id;
        return acc;
      }, {});
      results.forEach((res, index) => {
        requiredFields.forEach((element) => {
          if (!res[element]) {
            errors.push({
              message: `Please fill in ${element} column`,
              row: index + 1,
            });
          }
        });
      });
      this.importedData = results.map((person, index) => ({
        firstName: person.firstName.toString(),
        middleName: person.fatherName.toString(),
        lastName: person.grandfatherName.toString(),
        gender: person.gender.toString(),
        phoneNumber: person.phoneNumber.toString(),
        facilityEmail: person.emailAddress.toString(),
        national_id: person.nationalId.toString(),
        kebele: person.kebele.toString(),
        employeeId: person.employeeId.toString(),
        licenseNumber: person.licenseNumber.toString(),
        prefix: person.prefix.toString(),
        unemployed: person.unemployed.toString(),
        regionId: regionLookup[person.region] || errors.push({
          message: `Please fill the region column through select only`,
          row: index + 1,
        }),
        professionId: professionLookup[person.profession] || errors.push({
          message: `Please fill the profession column through select only`,
          row: index + 1,
        }),
      }));

      if (errors.length > 1) {
        errors = errors.reduce(function (r, a) {
          r[a.row] = r[a.row] || [];
          r[a.row].push(a.message);
          return r;
        });
        delete errors["message"];
        delete errors["row"];
        this.importErrors = errors;
        this.importErrorsDialog = true;
        return;
      } else {
        this.importErrorsDialog = false;
        this.showUpload = true;
        this.fileName = fileName;

        this.csvHeaders = [
          {text: "Prefix", value: "prefix"},
          {text: "First Name", value: "firstName"},
          {text: "Father Name", value: "fatherName"},
          {text: "Grandfather Name", value: "grandfatherName"},
          {text: "Gender", value: "gender"},
          {text: "Profession", value: "profession"},
          {text: "Region", value: "region"},
          {text: "Kebele", value: "kebele"},
          {text: "Unemployed", value: "unemployed"},
          {text: "Email Address", value: "emailAddress"},
          {text: "Phone Number", value: "phoneNumber"},
          {text: "Employee Id", value: "employeeId"},
          {text: "License Number", value: "licenseNumber"},
          {text: "National Id", value: "nationalId"},
        ]
        this.csvResults = results;
        this.showCsv = true;
      }
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$toast.warning("Please do not upload files larger than 1m in size.");
      return false;
    },
    async uploadTrainees() {
      if (this.csvResults.length === 0) {
        this.$toast.error("No file detected, Please provide one!");
        return;
      }
      this.loading = true;
      let res = await TraineeService.importTrainees(this.importedData);
      if (res.status === 200) {
        this.showUpload = false;
        switch (res.data.status) {
          case 200:
            this.$toast.success(res.data.message);
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
      } else {
        this.showUpload = false;
        this.$toast.error(
            "There was a problem uploading file, Please try Again!"
        );
      }
    },
    async prepareExel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');

      // Sample JSON data
      const headers = [
        "prefix",
        "firstName",
        "fatherName",
        "grandfatherName",
        "gender",
        "profession",
        "region",
        "kebele",
        "unemployed",
        "emailAddress",
        "phoneNumber",
        "employeeId",
        "licenseNumber",
        "nationalId"
      ];
      worksheet.addRow(headers);
      worksheet.dataValidations.add('A2:A999', {
        type: 'list',
        allowBlank: false,
        formulae: ['"Ato (Mr),W/ro (Mrs),W/rt (Ms),DR"'],
      });
      worksheet.dataValidations.add('E2:E999', {
        type: 'list',
        allowBlank: false,
        formulae: ['"Male, Female"'],
      });
      const professions = this.PROFESSIONS.map((data) => data.name).join(',').toString();
      worksheet.dataValidations.add('F2:F999', {
        type: 'list',
        allowBlank: false,
        formulae: [`"${professions}"`],
      });
      const regions = this.REGIONS.map((data) => data.name).join(',').toString();
      worksheet.dataValidations.add('G2:G999', {
        type: 'list',
        allowBlank: false,
        formulae: [`"${regions}"`],
      });
      worksheet.dataValidations.add('I2:I999', {
        type: 'list',
        allowBlank: false,
        formulae: ['"Yes, No"'],
      });
      worksheet.dataValidations.add('K1:K999', {
        type: 'textLength',
        operator: 'between',
        showErrorMessage: true,
        allowBlank: false,
        error: 'You Must Enter a valid phone number',
        formulae: [9, 14]
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'trainee_template.xlsx');
    },
  }
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%) !important;
}
</style>
